import { useContext } from 'react';

import { SignUpWizardContext } from '@/contexts/SignUpWizardContext';
import { ValidationErrorMessages } from '@jetslash/market-frontend-shared-core/src/utilities/form/types';
import { ICurrentUser } from '@jetslash/market-frontend-shared-core/src/types/models/user';

interface IHookReturns {
  loading: boolean;
  errors: ValidationErrorMessages;
  signUpUserIsHydrated: boolean;
  signUpStepStartRequest?: () => void;
  signUpStepSuccess?: (newToken?: string | null, loading?: boolean | null) => void;
  signUpStepFailure?: (errors: ValidationErrorMessages) => void;
  setSignUpUser?: (user: ICurrentUser, clearErrors?: boolean) => void;
  signUpUser?: ICurrentUser;
  updateSignUpUser?: () => Promise<ICurrentUser>;
}

const useSignUpWizard = (): IHookReturns => {
  const {
    loading,
    errors,
    signUpUser,
    signUpUserIsHydrated,
    signUpStepStartRequest,
    signUpStepSuccess,
    signUpStepFailure,
    setSignUpUser,
    updateSignUpUser,
  } = useContext(SignUpWizardContext);
  return {
    loading,
    errors,
    signUpUser,
    signUpUserIsHydrated,
    signUpStepStartRequest,
    signUpStepSuccess,
    signUpStepFailure,
    setSignUpUser,
    updateSignUpUser,
  };
};
export default useSignUpWizard;
